<template>
  <option-modal
    class="myworkflows-rename-modal"
    title-modal="Rename"
    :apply-btn="applyBtn"
    @on-close="close"
  >
    <p class="body-1">Please enter a new name for the experiment.</p>
    <input-area
      tag="input"
      label="Experiment name"
      v-model="name"
    />
  </option-modal>
</template>

<script>
import saveWorkflow from '@/components/workflow/mixins/saveWorkflow';
import { showGlobalBanner } from '@/services/global-banner.js';
import callToApiBackend from '@/components/workflow/mixins/callToApiBackend';
import OptionModal from './option-modal';
import saveToLocalStorage from '@/components/workflow/mixins/saveToLocalStorage';

export default {
  name: "OptionModalRename",
  components: { OptionModal },
  mixins: [ saveWorkflow, callToApiBackend, saveToLocalStorage ],
  props: {
    currentWorkflow: { type: Object }
  },
  data() {
    return {
      name: '',
    }
  },
  created() {
    this.name = this.currentWorkflow.title;
  },
  computed: {
    applyBtn() {
      return {
        name: 'Rename',
        disabled: !this.name,
        func: this.apply,
      }
    }
  },
  methods: {
    renameWorkflow(name) {
      this.$store.commit('renameWorkflowName', {
        newName: name,
        workflow: this.currentWorkflow
      });
    },
    close() {
      this.$emit('on-close')
    },
    apply() {
      const workflowNewName = {
        ...this.currentWorkflow,
        title: this.name,
        publication_id: this.$store.state.hcube.publication_id,
      }
      this.close();
      this.updateSingleWorkflowAPI('put', this.currentWorkflow.id, workflowNewName)
        .then((d) => {
          if(d.title) {
            this.renameWorkflow(d.title);
            this.updateTitleInLsMyWorkflows(this.currentWorkflow.id, d.title);
          }
          this.$snackbar({title: 'Experiment renamed.', btn: null, duration: 6000});
        })
        .catch(() => {
          showGlobalBanner(this, {
            title: 'Experiment could not be renamed.',
            body: 'Due to technical reasons, we were unable to rename this experiment. Please try again.',
            btn: 'dismiss',
          });
        });
    }
  },
}
</script>

<style lang="scss">
.myworkflows-rename-modal {
	.body-1 {
		padding-bottom: 8px;
	}
}
</style>
